<!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
<template>
  <div class="banner">
    <v-app-bar
      fixed
      app
      max-width="100%"
      class="mx-auto darken-5 copblue mt-n1 mt-lg-0"
      absolute
      dense
    >
      <div class="badge_logoff d-flex justify-space-between align-center">
        <div style="width: 10px"></div>
        <div>
          <v-img
            max-width="166"
            height="80%"
            width="auto"
            src="../images/badgesex150_40_3_white.png"
          ></v-img>
        </div>
        <div id="div_logoff">
          <v-btn icon text v-show="true" @click="toggle_logoff">
            <v-icon x-large>$person</v-icon>
          </v-btn>
        </div>
      </div>
    </v-app-bar>
    <div
      class="black--text barbexpand"
      @click="logoff"
      style="
        z-index: 500;

        text-decoration: underline;
        cursor: pointer;
        position: absolute;
        top: 40px;
        right: 50px;
        padding: 10px;
        border-radius: 4px;
      "
      v-if="showLogoff"
    >
      Logoff: {{ user_email }}
    </div>

    <v-navigation-drawer
      id="v-navigation-drawer"
      height="100"
      v-model="drawer"
      absolute
      temporary
    >
      <v-list nav dense close-on-click close-on-content-click>
        <v-list-item-group v-model="group" active-class="primary white--text">
          <v-list-item>
            <v-list-item-icon>
              <v-icon>$home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>$logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .badge_logoff {
    width: 96%;
    margin: 0 auto;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
  .banner header {
    width: 98%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
export default {
  name: "brandbar",
  data: function () {
    return {
      showLogoff: false,
      user_email: "",
      app_title: "",
      drawer: false,
      group: null,
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      if (this.$store.state.user != "") {
        this.user_email = this.$store.state.user.email;
      }
    },
  },
  methods: {
    toggle_logoff() {
      this.showLogoff = !this.showLogoff;
    },
    logoff() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
i.v-icon.v-icon {
  color: red;
}

.v-icon {
  color: #ffffff !important;
}
</style>
